import moment from 'moment';
import React, { Component } from 'react';
import PrimaryButtonGE from 'src/Components/PrimaryButtonGE/PrimaryButtonGE';
import { emptyUserListConstants } from './emptyUserListConstants';
import { AnalyticsService } from 'src/Analytics/AnalyticsService';
import './styles.scss';

export default class NoUsersYet extends Component {
  renderDate = () => {
    let { subDate } = this.props;
    return moment(subDate).format('MMM DD, YYYY');
  };

  handleAddAdminClick = () => {
    const { activePage } = this.props;

    if (typeof window['digitalData'] !== 'undefined') {
      window.digitalData.link = {
        linkName: emptyUserListConstants.getStarted[activePage].btnText,
        linkType: 'ADD ADMIN',
      };
    }

    AnalyticsService.trackEvent('link_click');
    this.props.addAdmin();
  };

  render() {
    const { activePage } = this.props;
    const activeKey = this.props.page;
    return (
      <div className="empty-users-wrapper">
        <section className="img-heading-info-container">
          <img src={emptyUserListConstants[activeKey].img} alt="no-list" />
          <h2 className="no-list-heading">
            {emptyUserListConstants[activeKey].heading}
          </h2>
          <p className="no-list-info">
            {emptyUserListConstants[activeKey].text}{' '}
            {activeKey === 'subsNotStarted' && this.renderDate()}
          </p>
          {activeKey === 'getStarted' && (
            <PrimaryButtonGE
              text={emptyUserListConstants.getStarted[activePage].btnText}
              className="add-admin-btn"
              onClick={this.handleAddAdminClick}
            />
          )}
        </section>
      </div>
    );
  }
}
